module.exports = __webpack_public_path__ + "img/timer_blue.4bd1d355.svg";